export default __webpack_public_path__ + "static/media/icon-win-10.ea3ee86d.svg";